import { TPromoCallback } from '~/src/features/specialOffersContainer/types';

export const getDefaultCallback = <T extends TPromoCallback>(key: T) => ({
    DefaultCallback: key,
});
